import React, { Fragment, useEffect, useState, useRef } from "react";
import ActionBar from "../../common/ActionBar/index";
import theme from "../../../assets/theme";
import OrganisationService from "../../../services/OrganisationService";
import styled from "styled-components";
import CustomTable from "../../common/CustomTable/MaterialCustomTable";
import labels from "../../../helpers/labels.json";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";

const ViewOrganisation = () => {
  const [state, setState] = useState();
  const MTRef = useRef();
  const [selectedFilter, setSelectedFilter] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);

  const columns = [
    {
      field: "orgId",
      title: "Organisation ID",
      sorting: true,
      render: (rowData) => <Center>{rowData.orgId}</Center>,
      width: 150,
    },
    {
      field: "orgName",
      title: "Organisation Name",
      sorting: true,
      render: (rowData) => <Center>{rowData.orgName}</Center>,
      width: 280,
    },
    {
      field: "contactName",
      title: labels.contact_name,
      render: (rowData) => <Center>{rowData.contactName}</Center>,
      width: 210,
    },
    {
      field: "contactNumber",
      title: labels.contact_number,
      sorting: true,
      render: (rowData) => <Center>{rowData.contactNumber}</Center>,
      width: 180,
    },
    {
      field: "mailId",
      title: labels.email_id,
      sorting: false,
      render: (rowData) => <Center>{rowData.mailId}</Center>,
    },
  ];

  useEffect(() => {
    async function getOrganizationData() {
      try {
        const response = await OrganisationService.allOrganizationList();
        setState({ data: response.organizations });
      } catch (error) {
        setState({ data: [] });
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoading(false);
      }
    }
    getOrganizationData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <ActionBar breadcrumbs={["View Organization"]} />
      <Padding>
        <CustomTable
          hidePagination={state?.lastPage === 1}
          pageSize={state?.length ? state?.length : 10}
          pluralTitle={"Organization"}
          singularTitle={"Organization"}
          placeholderText={"Search"}
          noToolbar={true}
          {...{
            columns,
            selectedFilter,
            setSelectedFilter,
            MTRef,
          }}
          loading={loading}
          data={state?.data}
          hideFilterBar
          state={state}
        />
      </Padding>
    </Fragment>
  );
};

export default ViewOrganisation;

const Padding = styled.div`
  // padding: 30.3px 15px 15.7px 15px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-top: 10px;
    padding-bottom: 50px;
    padding-left: 35px;
    padding-right: 53px;
  }
`;

export const HeadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 12px;
`;

export const ActionButton = styled.button`
  border: none;
  background: none;
  outline: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 12px;
`;

const Center = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: #8294a5;
  font-weight: 600;
`;
